
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Rol } from '../shared/rol.model';
import {
    TYPEMODULE, LoaderService, NotificationService, UtilityService,
    ErrorService, TYPEMESSAGE
} from '../../../../shared/session/index';
import { RolService } from '../shared/rol.service';

@Component({
    //moduleId: module.id,
    selector: 'app-rol-view',
    templateUrl: 'rol-view.component.html'
})
export class RolViewComponent implements OnInit {
    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
    @Input() typeModule: TYPEMODULE;
    @Input() titlePage: string;
    @Input() data: any;
    // @Input() ID:number;

    rol: Rol;
    msgErrorGet: string;

    constructor(private loaderService: LoaderService, private rolService: RolService,
        private errorService: ErrorService, private notificationService: NotificationService,
        private utilityService: UtilityService) { }

    ngOnInit() {
        this.rol = new Rol();
        this.msgErrorGet = 'Error al obtener datos';
        this.obtenerRol(this.data.rol.ID);
    }

    private obtenerRol(rolID: number): void {
        this.loaderService.show();
        this.rolService.obtenerRol(rolID)
            .subscribe(res => {
                this.rol = res;
                this.utilityService.setAuditoria(this.rol);
                // if (this.errorService.getResultMessageError2(res)) {
                //     this.rol = res.Data;
                //     this.utilityService.setAuditoria(this.rol);
                // }
            },
                error => {
                    this.notificationService.error(this.msgErrorGet);
                    throw error;
                },
                () => {
                    this.loaderService.hide();
                });
    }
}
